import authService from './AuthService';

export const STREAK_PROTECTION_CHANGED = 'streakProtectionChanged';
let protectionRevision = 0;
const accountTimezones = new Map();

export function rememberProtectionContext(data) {
  const userId = authService.getCurrentUserId();
  if (userId && data?.enabled && typeof data.timezone === 'string') {
    try {
      new Intl.DateTimeFormat('en', { timeZone: data.timezone }).format();
      accountTimezones.set(userId, data.timezone);
    } catch { /* Ignore malformed optional data without replacing known context. */ }
  }
  return data;
}

export function getAccountTimezone() {
  return accountTimezones.get(authService.getCurrentUserId()) || null;
}

export function getClientTimezone() {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (typeof timezone !== 'string' || !timezone) return null;
    new Intl.DateTimeFormat('en', { timeZone: timezone }).format();
    return timezone;
  } catch { return null; }
}

export function getTimezoneHeaders() {
  const timezone = getClientTimezone();
  return timezone ? { 'X-Client-Timezone': timezone } : {};
}

export function getAccountToday(timezone, now = new Date()) {
  if (!timezone) return null;
  try {
    const parts = new Intl.DateTimeFormat('en', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
    return `${values.year}-${values.month}-${values.day}`;
  } catch { return null; }
}

export function getProtectionRevision() { return protectionRevision; }

export function notifyStreakProtectionChanged() {
  protectionRevision += 1;
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(STREAK_PROTECTION_CHANGED));
}

export function createProtectionOperationId() {
  return window.crypto?.randomUUID?.() || `vacation-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
